/* eslint-disable angular/controller-as */

angular.
module("dx.webapp.import").
controller("DxImportReportPopupController", function ImportReportPopupController(
	$scope,

	DX_QUESTION_TYPE,
	DX_QTI_QUESTION_TYPE,

	dxLocalize,
	dxDialog
) {
	"use strict";

	$scope.questionTypeKeys = [];

	// Resolve they localization keys for question types once so it's not done on
	// every digest cycle.
	for (var i = 0; i < $scope.importResult.questionImportResults.length; i++) {
		var result = $scope.importResult.questionImportResults[i];
		var key = "";

		switch (result.dxQuestionType) { // eslint-disable-line default-case
			case DX_QUESTION_TYPE.TEXT:
				key = "TextQuestion";
				break;

			case DX_QUESTION_TYPE.SINGLE_CHOICE:
				key = "SingleChoiceQuestion";
				break;

			case DX_QUESTION_TYPE.MULTIPLE_CHOICE:
				key = "MultiChoiceQuestion";
				break;
		}

		if (!key) {
			var questionTypeKey = "UNIDENTIFIED";

			for (var typeKey in DX_QTI_QUESTION_TYPE) {
				if (DX_QTI_QUESTION_TYPE.hasOwnProperty(typeKey) &&
					result.qtiQuestionType === DX_QTI_QUESTION_TYPE[typeKey]) {
					questionTypeKey = typeKey;
					break;
				}
			}

			key = "QuestionType." + questionTypeKey;
		}

		$scope.questionTypeKeys.push(key);
	}


	$scope.getQuestionTitle = function getQuestionTitle($index, questionResult) {
		var title = questionResult.title;

		if (!title) {
			title = dxLocalize.get("Question") + " " + ($index + 1);
		}

		return title;
	};

	$scope.close = function close() {
		dxDialog.closeMostRecent();
	};
});
